/* 🤖 this file was generated by svg-to-ts */
export const siriusWarningLightPictogram: {
  name: 'warning_light_pictogram';
  data: string;
} = {
  name: 'warning_light_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M22.496 28.125v-7.5a1.125 1.125 0 1 1 2.25 0v7.5a1.125 1.125 0 0 1-2.25 0Zm21.194 12.56a4.084 4.084 0 0 1-3.574 2.063H7.126a4.125 4.125 0 0 1-3.571-6.19l16.496-28.5a4.125 4.125 0 0 1 7.14 0l16.495 28.5a4.083 4.083 0 0 1 .004 4.126Zm-1.951-3-16.495-28.5a1.875 1.875 0 0 0-3.246 0l-16.496 28.5a1.875 1.875 0 0 0 1.623 2.813h32.991a1.875 1.875 0 0 0 1.623-2.814ZM23.62 33a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Z" fill="currentColor"/></svg>`
};
